var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Menu'),(!_vm.mobileView)?_c('Socialmedia'):_vm._e(),(_vm.mobileView)?_c('div',[(!this.$store.state.formFocus)?_c('ContactFooter'):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }